import type { Graph, DescriptorEnumItem } from "@lr-notitia/notitia-model-store/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";
import { DescriptorDatatype } from "@lr-notitia/notitia-designer/schemas";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const enumItems = (graph: Ref<Graph>) =>
	computed<DescriptorEnumItem[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "enum-item" && node.layer === "descriptor"
			) as DescriptorEnumItem[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
				)
		);
	});

export function enumItem(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => {
			return graph.value.nodes[id] as DescriptorEnumItem | undefined;
		},
		byDatatype: (datatypeId: string) => {
			const datatype = graph.value.nodes[datatypeId] as DescriptorDatatype | undefined;
			if (!datatype || datatype.type !== "datatype" || !datatype.enumerationItems) return [];

			return datatype.enumerationItems
				.map((enumId) => graph.value.nodes[enumId] as DescriptorEnumItem)
				.filter(Boolean)
				.sort((a, b) =>
					symbolsStore
						.term({ id: a.refersTo, terminology: a.terminology || {} })
						.toLocaleLowerCase()
						.localeCompare(
							symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
						)
				);
		},
	};
}
